export abstract class DependentFilter<T> {
  abstract updateParams(params: Partial<T>): void;
}
